<template>
  <ul class="t-pagination">
    <li
      class="t-pagination__page-item t-pagination__nav t-pagination__nav--prev"
      :class="{'t-pagination__nav--disabled': !allowPrev}">
      <a class="t-pagination__link"
         href="#"
         aria-label="Previous"
         @click.prevent="previousPage">
        <slot name="prev-nav">
          <t-icon icon="chevron-left" size="sm"/>
        </slot>
      </a>
    </li>

    <li v-for="(page, key) in pageRange"
        class="t-pagination__item t-pagination__page-nav"
        :key="key"
        :class="{
          't-pagination__item--active': page === currentPage,
          't-pagination__item--dots': page === '...'
        }">
      <a class="t-pagination__link" href="#" @click.prevent="selectPage(page)">
        {{ page }}
      </a>
    </li>

    <li
      class="t-pagination__item t-pagination__nav t-pagination__nav--next"
      :class="{'t-pagination__nav--disabled': !allowNext}">
      <a class="t-pagination__link"
         href="#"
         aria-label="Next"
         @click.prevent="nextPage">
        <slot name="next-nav">
          <t-icon icon="chevron-right" size="sm"/>
        </slot>
      </a>
    </li>
  </ul>
</template>

<script>
import { TIcon } from '../TIcon';

export default {
  name: 't-pagination',
  components: { TIcon },
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
  },
  computed: {
    limit() {
      return 1;
    },
    lastPage() {
      return Math.ceil(this.total / this.perPage);
    },
    allowPrev() {
      return this.currentPage !== 1;
    },
    allowNext() {
      return this.currentPage !== this.lastPage;
    },
    pageRange() {
      if (this.limit === -1) {
        return 0;
      }
      if (this.limit === 0) {
        return this.lastPage;
      }

      const current = this.currentPage;
      const last = this.lastPage;
      const delta = this.limit;
      const left = current - delta;
      const right = current + delta + 1;
      const range = [];
      const pages = [];
      let l;
      for (let i = 1; i <= last; i += 1) {
        if (i === 1 || i === last || (i >= left && i < right)) {
          range.push(i);
        }
      }
      range.forEach((i) => {
        if (l) {
          if (i - l === 2) {
            pages.push(l + 1);
          } else if (i - l !== 1) {
            pages.push('...');
          }
        }
        pages.push(i);
        l = i;
      });
      return pages;
    },
  },
  methods: {
    previousPage() {
      this.selectPage((this.currentPage - 1));
    },
    nextPage() {
      this.selectPage((this.currentPage + 1));
    },

    selectPage(page) {
      if (page === '...') {
        return;
      }

      this.$emit('change', page);
    },
  },
};
</script>
